import React, { useState, useLayoutEffect, useEffect } from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import Ellipse from 'src/components/elements/Ellipse';
import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import metrics from 'src/utility/metrics';

import { APP_URL, S3_IMAGES_URL, S3_MP4_URL } from '../../constants';

import { gsap } from 'gsap';

import styles from './MainScreen.scss';

const MainScreen = () => {
  const [scrollY, setScrollY] = useState(0);
  const { isDesktop } = useLayoutContext();

  const downloadClick = (event) => {
    event.preventDefault();
    metrics('SOLAR_LANDING_INSTALL_BUTTON', { trigger: 'main screen' });
    window.open(APP_URL);
  };

  useLayoutEffect(() => {
    const timeline = gsap.timeline({ repeat: -1 });

    gsap.set('#main-screen-title-1', { display: 'none' });
    gsap.set('#main-screen-title-2', { display: 'none' });
    gsap.set('#ellipse', { opacity: 0 });

    timeline
      .to('#main-screen-title-1', { display: 'block' }, '+=0.3')
      .to('#main-screen-title-1', { opacity: 0, y: -50 }, '+=3')
      .to('#main-screen-title-2', { display: 'block' })
      .to('#ellipse', { opacity: 1, duration: 3 })
      .to('#ellipse', { opacity: 0 }, '+=3')
      .to('#main-screen-title-2', { opacity: 0, y: -50 }, '<');
  }, []);

  useEffect(() => {
    const scrollY = () => setScrollY(window.scrollY);

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', scrollY);
    }

    return () => {
      window.removeEventListener('scroll', scrollY);
    };
  }, []);

  return (
    <div id="main-screen" className={styles.mainScreen}>
      <video
        autoPlay={true}
        preload="auto"
        loop={true}
        muted={true}
        playsInline={true}
        className={styles.video}
      >
        <source src={`${S3_MP4_URL}main_screen.mp4`} type="video/mp4" />
      </video>

      <div id="main-screen-title-1" className={clsx(styles.title, styles.titleAbsolute)}>
        <FadeIn animationRepeat={true}>
          <span className={styles.titleThin}>Your</span> ultimate
        </FadeIn>
        <FadeIn delay={1} animationRepeat={true}>
          <span className={styles.titleThin}>travel app</span>
        </FadeIn>
      </div>

      <div id="main-screen-title-2" className={clsx(styles.title, styles.titleAbsolute)}>
        <FadeIn animationRepeat={true}>
          <span className={styles.titleThin}>For discovering</span>
        </FadeIn>
        <FadeIn delay={1} animationRepeat={true}>
          <span>the world</span>
        </FadeIn>
      </div>

      <Ellipse id="ellipse" childrenClassNames={{ ellipse: styles.ellipse }} />

      {isDesktop ? (
        <FadeIn
          className={clsx(styles.qrCodeWrapper, {
            [styles.qrCodeWrapperHidden]: scrollY > 5200,
          })}
          delay={4.5}
        >
          <span className={styles.qrCodeTitle}>Download app</span>
          <img
            className={styles.qrCode}
            src={`${S3_IMAGES_URL}main_screen/qr_code.svg`}
            alt="qr-code"
          />
        </FadeIn>
      ) : (
        <FadeIn className={styles.downloadButton} delay={4.5}>
          <GradientButton darkGradient={true} onClick={downloadClick}>
            Download app
          </GradientButton>
        </FadeIn>
      )}
    </div>
  );
};

export default MainScreen;
